/* eslint-disable */
import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import App from './pages/app';
import PropertySearch from './pages/propertySearch';
import PropertyDetail from './pages/propertyDetail';
import Maintenance from './pages/Maintenance';

export const getRoutes = () => {
  // eslint-disable-line react/prop-types
  return (
    <Route
      path='/'
      render={props => (
        <App {...props}>
          <Switch>
            <Route
              component={PropertySearch}
              exact
              path='/taxTransparency/propertySearch'
            />
            <Route
              component={PropertyDetail}
              exact
              path='/taxTransparency/property/:propertyId'
            />
            <Route
              component={PropertyDetail}
              exact
              path='/taxTransparency/property/:propertyId/:ownerId'
            />
            <Route
              component={Maintenance}
              exact
              path='/maintenance'
            />
            <Redirect to='/taxTransparency/propertySearch' />
          </Switch>
        </App>
      )}
    />
  );
};
